<script setup lang="ts">
import { ref } from 'vue';
import { useClickAwayPanel } from '@/composables/useClickAwayPanel';

defineProps<{ label: string }>();

const root = ref<HTMLElement | null>(null);
// Open/close, Escape and the Kendo-aware outside-mousedown rule live in the composable, shared
// with the data lists' ElementWorldLink row action.
const { open, toggle: openMenu, close } = useClickAwayPanel({ anchors: [root] });

defineExpose({ close });
</script>

<template>
  <span ref="root" class="filter-popover">
    <button
      type="button"
      class="filter-chip filter-chip--suggested"
      :aria-label="`Add ${label} filter`"
      aria-haspopup="true"
      :aria-expanded="open"
      @click="openMenu"
    >
      <span class="fa-light fa-plus" aria-hidden="true"></span>
      <span class="filter-chip-label" v-html="label"></span>
    </button>
    <div v-if="open" class="filter-popover-menu">
      <slot />
    </div>
  </span>
</template>
